<template>
  <div>
    <HeaderCont />
    <TitleCont name1="youtube" name2="reference api" />
    <section class="cont__refer">
      <div class="container">
        <div class="youtube__inner">
          <div class="youtube__slider">
            <h2>오늘의 추천영상</h2>
            <swiper
              :grabCursor="true"
              :slidesPerView="3"
              :spaceBetween="30"
              :sliderPerGroup="3"
              effect="creative"
              :loopFillGroupWithBlank="true"
              :loop="true"
              :autoplay="{
                delay: 3000,
                disableOnInteraction: false,
              }"
              :pagination="true"
              :modules="modules"
              class="mySwiper"
            >
              <swiper-slide v-for="slider in sliders" :key="slider.id">
                <a
                  :href="`https://www.youtube.com/watch?v=${slider.id.videoId}`"
                >
                  <img
                    :src="slider.snippet.thumbnails.high.url"
                    :alt="slider.snippet.title"
                  />
                  <em>
                    <span class="title">{{ slider.snippet.title }}</span>
                  </em>
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <!-- 01 -->

          <div class="youtube__search">
            <div class="container">
              <form @submit.prevent="SearchYoutube()">
                <input
                  type="search"
                  id="search"
                  placeholder="검색하기"
                  v-model="search"
                />
                <button type="sumbit">검색</button>
              </form>
            </div>
          </div>
          <!-- 02 -->

          <div class="cont__youtubeBtn">
            <h2>Keywords</h2>
            <ul className="youtube__btn">
              <li @click="select" v-for="k in keyword" :key="k.name">
                {{ k.name }}
              </li>
            </ul>
          </div>

          <div class="youtube__video">
            <ul>
              <li v-for="youtube in youtubes" :key="youtube.id">
                <a
                  :href="`https://www.youtube.com/watch?v=${youtube.id.videoId}`"
                >
                  <img
                    :src="youtube.snippet.thumbnails.high.url"
                    :alt="youtube.snippet.title"
                  />
                  <em>
                    <span className="title">{{ youtube.snippet.title }}</span>
                  </em>
                </a>
              </li>
            </ul>
          </div>
          <!-- 03 -->
        </div>
      </div>
    </section>
    <ContactCont />
    <FooterCont />
  </div>
</template>

<script>
import HeaderCont from "@/components/HeaderCont.vue";
import TitleCont from "@/components/TitleCont.vue";
import ContactCont from "@/components/ContactCont.vue";
import FooterCont from "@/components/FooterCont.vue";

import { ref } from "vue";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/bundle";

// import required modules
import { Autoplay, Pagination } from "swiper";

export default {
  components: {
    HeaderCont,
    TitleCont,
    ContactCont,
    FooterCont,
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      keyword: [
        { name: "New York" },
        { name: "Berlin" },
        { name: "Helsinki" },
        { name: "London" },
        { name: "Tokyo" },
        { name: "Seoul" },
        { name: "Stockholm" },
      ],
    };
  },

  setup() {
    const youtubes = ref([]);
    const sliders = ref([]);
    const search = ref("webstoryboy");

    const SearchYoutube = () => {
      const requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `https://youtube.googleapis.com/youtube/v3/search?part=snippet&q=${search.value}&key=AIzaSyAmOyKrz9aq1HX5kEwKEUGNmAvJ11pAkwo&maxResults=30&type=video`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          youtubes.value = result.items;
          search.value = "";
        })
        .catch((error) => console.log("error", error));
    };
    SearchYoutube();

    const RandomYoutube = () => {
      const requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        "https://www.googleapis.com/youtube/v3/search?part=snippet&q=webstoryboy&key=AIzaSyAmOyKrz9aq1HX5kEwKEUGNmAvJ11pAkwo&maxResults=20&type=video",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          sliders.value = result.items;
        })
        .catch((error) => console.log("error", error));
    };
    RandomYoutube();

    return {
      youtubes,
      search,
      sliders,
      SearchYoutube,
      RandomYoutube,
      modules: [Autoplay, Pagination],
    };
  },

  methods: {
    select: function (event) {
      this.search = event.currentTarget.textContent;
      this.SearchYoutube();
    },
  },
};
</script>

<style lang="scss">
.youtube__video {
  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-bottom: 20px;
      width: 23%;
      margin-right: 2%;

      &:last-child {
        margin-right: 0;
      }

      img {
        border-radius: 5px;
      }
      em {
        display: block;
        margin-bottom: 30px;
        height: 80px;
        font-family: var(--font-sub3);
      }
      .title {
        display: inline-block;
        padding: 5px 0;
      }
    }
  }
  a {
    color: var(--black);
    font-family: var(--font-sub3);
  }
}

.youtube__search {
  margin-bottom: 100px;

  .container {
    position: relative;
  }

  h2 {
    color: var(--white);
    font-size: 40px;
    text-indent: -9999px;
    height: 0;
  }
  input {
    background: #fff;
    border: 2px solid var(--black);
    border-radius: 50px;
    color: #000;
    width: 100%;
    padding: 15px 30px;
    font-family: var(--font-sub3);
    margin-top: 50px;
  }
  button {
    position: absolute;
    right: 0;
    top: 50px;
    width: 100px;
    height: 56px;
    border-radius: 50px;
    border: 0;
    font-family: var(--font-sub3);
    cursor: pointer;
    z-index: 1000;
    background: #000;
    color: #fff;
  }
}

.youtube__slider {
  h2 {
    color: var(--black);
    text-align: center;
    margin: 25px 0 10px 0;
    font-family: var(--font-sub3);
    font-size: 30px;
  }

  .swiper {
    width: 100%;
    height: 500px;
    margin-top: 20px;

    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      bottom: -0px !important;
    }

    .swiper-pagination-bullet {
      background: var(--black);
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #fff;

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      em {
        display: block;
        height: 80px;
        font-family: var(--font-sub3);
      }

      .title {
        font-size: 18px;
        display: inline-block;
        text-align: center;
        // padding: 5px 0;
      }
    }
  }

  a {
    color: var(--black);
  }
}

.cont__youtubeBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h2 {
    color: var(--black);
    text-align: center;
    margin: 25px 0 0 0;
    font-family: var(--font-sub3);
  }

  .youtube__btn {
    display: flex;
    li {
      border: 1px solid #000;
      border-radius: 50px;
      font-family: var(--font-sub2);
      padding: 5px 10px;
      margin: 10px 5px 20px 5px;
      color: var(--black);
      cursor: pointer;
      transition: all 300ms;

      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }
}
</style>
